var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    staticClass: "mt-5",
    attrs: {
      "title": "Dados Gerais",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "motorista",
      "label-for": "motorista",
      "label": "Motorista"
    }
  }, [_c('VueSelect', {
    ref: "buscarMotorista",
    class: {
      hasErrors: _vm.motoristaError
    },
    attrs: {
      "filterable": false,
      "options": _vm.motoristas
    },
    on: {
      "search": _vm.onSearchMotoristas,
      "input": function input() {
        return _vm.motoristaError = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " ")])];
      }
    }]),
    model: {
      value: _vm.motorista,
      callback: function callback($$v) {
        _vm.motorista = $$v;
      },
      expression: "motorista"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do motorista ")])], 2)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "tipo_emissor1",
      "label-for": "tipo_emissor1",
      "label": "Tipo Emissor"
    }
  }, [_c('VueSelect', {
    ref: "selectTipoEmissor",
    class: {
      hasErrors: _vm.emissorError
    },
    attrs: {
      "filterable": false,
      "searchable": false,
      "options": _vm.emissores
    },
    on: {
      "input": function input() {
        return _vm.emissorError = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.tipo_emissor,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tipo_emissor", $$v);
      },
      expression: "form.tipo_emissor"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Carregando ")])], 2)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "data_jornada",
      "label-for": "data_jornada",
      "label": "Data da Jornada"
    }
  }, [_c('b-form-datepicker', {
    attrs: {
      "state": _vm.validateState('data_jornada'),
      "locale": "pt-br",
      "date-format-options": {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }
    },
    model: {
      value: _vm.form.data_jornada,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "data_jornada", $$v);
      },
      expression: "form.data_jornada"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "hora_jornada",
      "label-for": "hora_jornada",
      "label": "Hora Jornada"
    }
  }, [_c('b-form-timepicker', {
    attrs: {
      "locale": "pt-br",
      "state": _vm.validateState('hora_jornada')
    },
    model: {
      value: _vm.form.hora_jornada,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "hora_jornada", $$v);
      },
      expression: "form.hora_jornada"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };